/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartExecutionResponse
 */
export interface StartExecutionResponse {
    /**
     * Unique execution ID
     * @type {string}
     * @memberof StartExecutionResponse
     */
    executionId: string;
    /**
     * ARN of the started state machine execution
     * @type {string}
     * @memberof StartExecutionResponse
     */
    stateMachineArn: string;
}

/**
 * Check if a given object implements the StartExecutionResponse interface.
 */
export function instanceOfStartExecutionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "executionId" in value;
    isInstance = isInstance && "stateMachineArn" in value;

    return isInstance;
}

export function StartExecutionResponseFromJSON(json: any): StartExecutionResponse {
    return StartExecutionResponseFromJSONTyped(json, false);
}

export function StartExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecutionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'executionId': json['executionId'],
        'stateMachineArn': json['stateMachineArn'],
    };
}

export function StartExecutionResponseToJSON(value?: StartExecutionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'executionId': value.executionId,
        'stateMachineArn': value.stateMachineArn,
    };
}

